interface String {
  PrimeiraLetraMaiuscula(): string;
  StringIsNullOrEmpty(): boolean;
}

String.prototype.PrimeiraLetraMaiuscula = function (): string {
  if (this.length === 0) {
    return this as string;
  }

  return this.charAt(0).toUpperCase() + this.slice(1).toLowerCase();
};

String.prototype.StringIsNullOrEmpty = function (): boolean {

  var str = this as string;
  return str === null || str === undefined || str.trim() === '';
};
